import React from 'react';
import './AnnotatedTargetImage.css';

interface AnnotatedTargetImageProps {
  imageUri: string;
  width?: number;
  height?: number;
  onError?: () => void;
}

const AnnotatedTargetImage: React.FC<AnnotatedTargetImageProps> = ({ 
  imageUri, 
  width = 350,
  height = 350,
  onError,
}) => {
  return (
    <div 
      className="annotated-target-container" 
      style={{ width: `${width}px`, height: `${height}px` }}
    >
      <img 
        src={imageUri} 
        alt="Target" 
        className="target-image"
        onError={() => {
          if (onError) {
            onError();
          }
        }}
      />
    </div>
  );
};

export default AnnotatedTargetImage;
